import React, { Fragment } from 'react';
import { Form, Divider } from 'antd';

// Steps
import Role from './formSection/Role'; // Должность
import UserName from './formSection/UserName'; // ФИО
import Phone from './formSection/Phone'; // Телефон
import BirthDate from './formSection/BirthDate'; // День рождение
import DriverLicense from './formSection/DriverLicense'; // Водительское удостоверение
import TachographCards from './formSection/TachographCards'; // Карты тахографа
import InfoACBPDP from './formSection/InfoACBPDP'; // Данные для АЦБПДП
// import Section7 from './formSection/Section7'; // Закрепленные ТС
// import Section8 from './formSection/Section8'; // Ограничения
import OtherUserInfo from './formSection/OtherUserInfo'; // Дополнительная информация
import DriverLicensePhoto from './formSection/DriverLicensePhoto'; // Фото ВУ
import Email from './formSection/Email'; // Email
// import RepresentativePhone from './formSection/RepresentativePhone'; // дополнительный телефон
// import RepresentativeEmail from './formSection/RepresentativeEmail'; // дополнительный телефон
// import RepresentativeUserName from './formSection/RepresentativeUserName'; // ФИО представителя

class Forms extends React.PureComponent {
  handleSubmit = () => {
    this.props.formSubmit();
  };

  render() {
    const {
      form,
      data,
      isEditable,
      validateField,
      profileId,
      filterOption,
      checkUserByPhoneNumber,
    } = this.props; // isDriver,

    const typeForm = profileId > 0 ? (isEditable ? 'edit' : 'view') : 'create';
    const roleKey = form.getFieldValue('roleKey');
    // const phone = form.getFieldValue('phone');
    const profileStatusKey = form.getFieldValue('profileStatusKey');
    const profileStatus = form.getFieldValue('profileStatus');

    const phone = form.getFieldsValue(['phone', 'phoneCode']);
    const phoneStatus =
      typeForm === 'create' &&
      phone.phoneCode &&
      phone.phone &&
      phone.phone.length > 9 &&
      checkUserByPhoneNumber &&
      checkUserByPhoneNumber.phone === `${phone.phoneCode}${phone.phone}` &&
      checkUserByPhoneNumber.status;
    // const phoneStatus = checkUserByPhoneNumber && checkUserByPhoneNumber.status;
    // const userExists = checkingPhoneNumber ;
    const isDriver = roleKey === 'driver';
    // const isManager = roleKey === 'manager';
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="add-employee__form">
          <Role
            form={form}
            validateField={validateField}
            isEditable={
              typeForm !== 'create' || (isDriver && typeForm === 'edit')
                ? false
                : isEditable
            }
            profileStatusKey={profileStatusKey}
            profileStatus={profileStatus}
          />
          <Phone
            form={form}
            validateField={validateField}
            isEditable={typeForm !== 'create' ? false : isEditable}
            checkIsLoading={
              typeForm === 'create' && phoneStatus === 'isLoading' && !isDriver
            }
            typeForm={typeForm}
          />
          {profileStatusKey !== 'wait' &&
            ((typeForm === 'create' && phoneStatus === 'notExist') ||
              typeForm !== 'create') && (
              <Fragment>
                {((isDriver && typeForm !== 'create') || !isDriver) && (
                  <UserName
                    form={form}
                    validateField={validateField}
                    isEditable={isDriver ? false : isEditable}
                  />
                )}
                {!isDriver && (
                  <Fragment>
                    <BirthDate
                      form={form}
                      validateField={validateField}
                      isEditable={isEditable}
                    />
                    <Email
                      form={form}
                      validateField={validateField}
                      isEditable={isDriver ? false : isEditable}
                    />
                    {/*TODO maybe next release (task_15081)*/}
                    {/*<Divider style={{ background: '#d9d9d9' }} />*/}
                    {/*<RepresentativeUserName*/}
                    {/*  form={form}*/}
                    {/*  validateField={validateField}*/}
                    {/*  isEditable={isEditable}*/}
                    {/*/>*/}
                    {/*<RepresentativeEmail*/}
                    {/*  form={form}*/}
                    {/*  validateField={validateField}*/}
                    {/*  isEditable={isEditable}*/}
                    {/*/>*/}
                    {/*<RepresentativePhone*/}
                    {/*  form={form}*/}
                    {/*  validateField={validateField}*/}
                    {/*  isEditable={isEditable}*/}
                    {/*/>*/}
                  </Fragment>
                )}
                {isDriver && typeForm !== 'create' && (
                  <Fragment>
                    <Divider style={{ background: '#d9d9d9' }} />
                    <DriverLicense
                      form={form}
                      validateField={validateField}
                      isEditable={false}
                    />
                    <Divider style={{ background: '#d9d9d9' }} />
                    <TachographCards
                      form={form}
                      validateField={validateField}
                      isEditable={false}
                    />
                    {roleKey === 'driver' && (
                      <BirthDate
                        form={form}
                        validateField={validateField}
                        isEditable={false}
                      />
                    )}
                    <InfoACBPDP
                      form={form}
                      filterOption={filterOption}
                      validateField={validateField}
                      isEditable={false}
                    />
                    {/*<Divider style={{ background: '#d9d9d9' }} />*/}
                    {/*<Section7*/}
                    {/*  form={form}*/}
                    {/*  change_values_form={this.change_values_form}*/}
                    {/*  data={data}*/}
                    {/*  isEditable={isEditable}*/}
                    {/*/>*/}
                    {/*<Divider style={{ background: '#d9d9d9' }} />*/}
                    {/*<Section8*/}
                    {/*  form={form}*/}
                    {/*  change_values_form={this.change_values_form}*/}
                    {/*  handle_show_excluded_ts={this.handle_show_excluded_ts}*/}
                    {/*  data={data}*/}
                    {/*  isEditable={isEditable}*/}
                    {/*/>*/}
                    <Divider style={{ background: '#d9d9d9' }} />
                    <OtherUserInfo
                      form={form}
                      validateField={validateField}
                      filterOption={filterOption}
                      isEditable={false}
                    />
                    <Divider style={{ background: '#d9d9d9' }} />
                    <DriverLicensePhoto
                      form={form}
                      change_values_form={this.change_values_form}
                      data={data}
                      isEditable={false}
                    />
                  </Fragment>
                )}

                {/*showAllFields && roleKey === 'driver' && profileId === 0 && (
                <Fragment>
                  <Divider style={{ background: '#d9d9d9' }} />
                  <Section7
                    form={form}
                    change_values_form={this.change_values_form}
                    data={data}
                    isEditable={isEditable}
                  />

                  <Divider style={{ background: '#d9d9d9' }} />
                  <Section8
                    form={form}
                    change_values_form={this.change_values_form}
                    handle_show_excluded_ts={this.handle_show_excluded_ts}
                    data={data}
                    isEditable={isEditable}
                  />
                </Fragment>
              )*/}
              </Fragment>
            )}
        </div>
      </Form>
    );
  }
}

export default Forms;
